import React from 'react';
import Immutable from 'immutable';
import { holdItemShape, bibShape, childrenShape } from '@bibliocommons/bc-prop-types';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import BorrowingBibBrief from '../../shared/BorrowingBibBrief';
import BibListItem from '../../../shared/BibListItem';
import AddToShelfButtonContainer from '../../../../containers/AddToShelfButtonContainer';
import ItemTransactionButtonContainer from '../../../../containers/ItemTransactionButtonContainer';
import ItemFormat from '../../../shared/ItemFormat';

import './InactiveHoldItem.scss';

export default class InactiveHoldItem extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderBibBrief', 'renderInfo');
  }

  getBriefOrPlaceholder() {
    return this.getBibBrief() || Immutable.Map({
      id: '',
      title: this.props.item.get('bibTitle')
    });
  }

  getBibBrief() {
    return this.props.bib && this.props.bib.get('briefInfo');
  }

  getWorkflowId() {
    return `inactive-hold-${this.props.item.get('holdsId')}`;
  }

  renderShelfButton() {
    const { item } = this.props;
    return this.getBibBrief() &&
      <AddToShelfButtonContainer
        metadataId={item.get('metadataId')}
        workflowId={this.getWorkflowId()} />;
  }

  renderPlaceHoldButton() {
    const { item } = this.props;
    return this.getBibBrief() && (
      <ItemTransactionButtonContainer
        id={item.get('metadataId')}
        workflowId={this.getWorkflowId()} />
    );
  }

  renderAdditionalBriefInformation() {
    return this.getBibBrief() && (
      <div className="bib-format-details">
        <ItemFormat bib={this.props.bib} />
      </div>
    );
  }

  renderBibBrief() {
    const bib = this.getBriefOrPlaceholder();
    return (
      <BorrowingBibBrief bib={bib}>
        {this.renderAdditionalBriefInformation()}
      </BorrowingBibBrief>
    );
  }

  renderInfo() {
    return (
      <div>
        {this.props.additionalDetails}
        <div className="actions">
          {this.renderPlaceHoldButton()}
          {this.renderShelfButton()}
        </div>
      </div>
    );
  }

  render() {
    const bib = this.getBriefOrPlaceholder();

    const result = (
      <BibListItem
        className="cp-inactive-hold-item"
        workflowId={this.getWorkflowId()}
        bib={bib}
        renderInfo={this.renderInfo}
        renderBibBrief={() => this.renderBibBrief()} />
    );

    return result;
  }
}

InactiveHoldItem.propTypes = {
  item: holdItemShape,
  additionalDetails: childrenShape,
  bib: bibShape
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/InactiveHoldItem/InactiveHoldItem.jsx